import { put, call, take, takeLatest, cancel, cancelled } from 'redux-saga/effects';
import axios from 'axios';
import { fetchSuccess, fetchFailed } from '../actions/weatherActions';
import WeatherService from '../services/WeatherService';

const fetchWeather = function* (action) {
    const cancelSource = axios.CancelToken.source();
    const token = cancelSource.token;

    try {
        // console.log('[WeatherSaga.jsx] SendRequest.WeatherList.jsx Action.data:', action.data);
        const { data } = yield call(WeatherService.getWeatherByPosition, action.data, token);
        console.log('[WeatherSaga.js] response from WeatherService', data) // Array of objects

        if (data.length === 0){ //Returned is an empty array
            throw {message:'Forecast Not Available'}
        }

        yield put(fetchSuccess(data)); //Calling REDUX ACTION to save/update state
        
    } catch (e) {
        console.log('[weatherSaga.js] Catched Error', e);
        yield put(fetchFailed(e));
    } finally {
        if (yield cancelled()) {
            yield call(cancelSource.cancel);
        }
    }
};

const fetchSLA = function* (action) {
    const cancelSource = axios.CancelToken.source();
    const token = cancelSource.token;

    try {
        // console.log('[WeatherSaga.jsx] SendRequest.WeatherList.jsx Action.data:', action.data);
        const { data } = yield call(WeatherService.getSLAByPosition, action.data, token);
        console.log('[WeatherSaga.js] response from SLAervice', data) // Array of objects

        if (data.length === 0){ //Returned is an empty array
            throw {message:'SLA TREND Not Available'}
        }

        yield put(fetchSuccess(data)); //Calling REDUX ACTION to save/update state
        
    } catch (e) {
        console.log('[weatherSaga.js] Catched Error', e);
        yield put(fetchFailed(e));
    } finally {
        if (yield cancelled()) {
            yield call(cancelSource.cancel);
        }
    }
};

const fetchWeatherWatcher = function* () {
    while (true) {
        const task = yield takeLatest('FETCH_WEATHER', fetchWeather);
        const slatask = yield takeLatest('FETCH_SLA', fetchSLA);
        // yield take('CANCEL_FETCH_WEATHER');
        // yield cancel(task);
    }
};


export default fetchWeatherWatcher;